import React from 'react';
import cn from 'classnames';

export const Item = ({ className, topClass, bottomClass, label, value }) => {
  return (
    <div className={className}>
      <span className={cn(topClass, 'DINPro')}>{label}</span>
      <span className={cn(bottomClass, 'DINPro')}>{value}</span>
    </div>
  )
}
